import { useState, useRef, useCallback } from "react";

interface LogoSpinProps {
  src: string;
  alt: string;
  className?: string;
}

export function LogoSpin({ src, alt, className = "" }: LogoSpinProps) {
  const [style, setStyle] = useState<React.CSSProperties>({});
  const isHovering = useRef(false);

  const onMouseEnter = useCallback(() => {
    isHovering.current = true;
    setStyle({
      animation: "spin-y 0.3s linear infinite",
    });
  }, []);

  const onMouseLeave = useCallback(() => {
    isHovering.current = false;
    // Switch to decel animation (different name so browser re-triggers)
    setStyle({
      animation: "spin-y-decel 3s cubic-bezier(0, 0, 0.15, 1) 1 forwards",
    });
  }, []);

  const onAnimationIteration = useCallback(() => {
    if (!isHovering.current) {
      setStyle({
        animation: "spin-y-decel 3s cubic-bezier(0, 0, 0.15, 1) 1 forwards",
      });
    }
  }, []);

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ ...style, transformStyle: "preserve-3d", backfaceVisibility: "visible" }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onAnimationIteration={onAnimationIteration}
    />
  );
}
